import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "teacherField", "directorField", "therapistField", "parentField", "schoolField"]

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasSelectTarget) return // GAR users have no role select: leave everything visible

    const role = this.selectTarget.value
    this.teacherFieldTargets.forEach((el) => this.toggle(el, role === "teacher"))
    this.directorFieldTargets.forEach((el) => this.toggle(el, role === "director"))
    this.therapistFieldTargets.forEach((el) => this.toggle(el, role === "therapist"))
    this.parentFieldTargets.forEach((el) => this.toggle(el, role === "parent"))
    this.schoolFieldTargets.forEach((el) => this.toggle(el, role !== "therapist"))
  }

  // Hidden required fields block form submission, so required is lifted while hidden.
  toggle(element, visible) {
    element.hidden = !visible
    element.querySelectorAll("[required], [data-was-required]").forEach((input) => {
      if (visible && input.dataset.wasRequired) {
        input.setAttribute("required", "required")
        delete input.dataset.wasRequired
      } else if (!visible && input.required) {
        input.dataset.wasRequired = "true"
        input.removeAttribute("required")
      }
    })
  }
}
